import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { IDocumentActionUserDecisionResult } from '@/models/document-actions.model';
import { DocumentFileVersionSign, FileHashingResult } from '@/models/document-sign.models';

export const documentSignsService = {
  userDecision,
  getHashesForSigningByCounterparty,
  getHashesForSigningByAuthor,
  saveAuthorSignatures,
  validateAuthorSign,
  validateCounterpartySign,
  allUserSignsGet,
  checkAuthorSignsSerials,
  cancelSign,
  downloadSignature
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'DocumentSigns'
};

function extract(r: any) {
  return r.data;
}

/*
 DSTU4145 =  1
 RSA  = 2
 ECDSA  = 4
*/
async function getHashesForSigningByCounterparty(pDocumentVersionCode, keyType) {
  return axios
    .get(`${model.baseUrl}${model.controller}/FilesHashesGet?pDocumentVersionCode=${pDocumentVersionCode}&keyType=${keyType}`)
    .then(extract);
}
/*
 DSTU4145 =  1
 RSA  = 2
 ECDSA  = 4
*/
async function getHashesForSigningByAuthor(pDocumentVersionCode: string, keyType: number, filesForSign: string): Promise<Array<FileHashingResult>> {
  let url = `${model.baseUrl}${model.controller}/FilesHashesForAutorsSignGet`;
  let query = `pDocumentVersionCode=${pDocumentVersionCode}&keyType=${keyType}&pDocumentVersionFileCodes=${filesForSign}`;

  let { data } = await axios.get<Array<FileHashingResult>>(`${url}?${query}`);

  return data;
}

async function validateAuthorSign(pDocumentVerFilesSignId: number, type: number, documentAccessToken: string = '') {
  let url = `${model.baseUrl}${model.controller}/ValidateAuthorSign`;
  url = `${url}?pDocumentVerFilesSignId=${pDocumentVerFilesSignId}`;
  url = `${url}&type=${type}`;
  url = `${url}&documentAccessToken=${documentAccessToken}`;
  return axios.get(url).then(extract);
}

async function validateCounterpartySign(documentSignUserSignsId: number, type: number, documentAccessToken: string = '') {
  let url = `${model.baseUrl}${model.controller}/ValidateCounterpartySign`;
  url = `${url}?documentSignUserSignsId=${documentSignUserSignsId}`;
  url = `${url}&type=${type}`;
  url = `${url}&documentAccessToken=${documentAccessToken}`;
  return axios.get(url).then(extract);
}

async function saveAuthorSignatures(pSign, pStamps, pIsReplacePreviewBySerial) {
  return axios
    .post(`${model.baseUrl}${model.controller}/FilesAutorsSignAdd`,
      { pSign: pSign, pStamps: pStamps, pIsReplacePreviewBySerial: pIsReplacePreviewBySerial })
    .then(extract);
}

async function userDecision(
  documentSignUserId: number,
  documentSignUserStatusId: number,
  signs: any,
  stamps: any,
  description?: string): Promise<IDocumentActionUserDecisionResult> {
  return axios
    .patch(`${model.baseUrl}${model.controller}/UserDecision`,
      { documentSignUserId, documentSignUserStatusId, signs, stamps, description })
    .then(extract);
}

async function allUserSignsGet(
  documentVersionCode: string,
  documentVersionFileCode: string,
  documentAccessToken: string = ''): Promise<Array<DocumentFileVersionSign>> {
  let url = `${model.baseUrl}${model.controller}/AllUserSignsGet`;
  url = `${url}?documentVersionCode=${documentVersionCode || ''}`;
  url = `${url}&documentVersionFileCode=${documentVersionFileCode || ''}`;
  url = `${url}&documentAccessToken=${documentAccessToken}`;

  let { data } = await axios.get<Array<DocumentFileVersionSign>>(url);

  return (data || []).map(d => new DocumentFileVersionSign(d));
}

async function checkAuthorSignsSerials(pSign, pStamps) {
  return axios
    .post(`${model.baseUrl}${model.controller}/FilesAutorsSignSerialCheck`, { pSign, pStamps })
    .then(extract);
}

async function cancelSign(documentVersionCode: string, description: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/CancelSign`, { documentVersionCode, description })
    .then(extract);
}

async function downloadSignature(documentVerFilesSignId: number, documentSignUserSignsId: number, documentAgreeUserSignsId: number,
  documentAcquaintUserSignsId: number, type: number, documentAccessToken: string = '') {
  let url = `${model.baseUrl}${model.controller}/DownloadSign`;
  url = `${url}?documentVerFilesSignId=${documentVerFilesSignId || 0}`;
  url = `${url}&documentSignUserSignsId=${documentSignUserSignsId || 0}`;
  url = `${url}&documentAgreeUserSignsId=${documentAgreeUserSignsId || 0}`;
  url = `${url}&documentAcquaintUserSignsId=${documentAcquaintUserSignsId || 0}`;
  url = `${url}&type=${type || 0}`;
  url = `${url}&documentAccessToken=${documentAccessToken || ''}`;
  return axios.get(url, { responseType: 'blob' });
}
